import React from 'react';
import { Box, Typography, IconButton, Paper, Chip } from '@mui/material';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { documentCardSx, terminalBarIconButtonSx } from '../../theme/terminalStyles';
import { formatMoney } from '../../helpers/dataFormatter';
import {
  incomingAiStatusColor,
  incomingAiStatusLabel,
  unresolvedLinesCount,
} from './incomingAiInvoiceUtils';

const IncomingAiInvoiceCard = ({ doc, onOpen }) => {
  const dateStr = doc.date ? new Date(doc.date).toLocaleDateString('uk-UA') : '—';
  const unresolved = unresolvedLinesCount(doc);
  const statusColor = incomingAiStatusColor(doc);

  return (
    <Paper sx={documentCardSx} elevation={0}>
      <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1.5 }}>
        <Box sx={{ width: 36, minWidth: 36, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' }}>
          <IconButton aria-label="відкрити" onClick={onOpen} sx={terminalBarIconButtonSx}>
            <OpenInNewOutlinedIcon />
          </IconButton>
          <Box aria-hidden sx={{ width: 24, height: 24, borderRadius: '50%', bgcolor: statusColor }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} noWrap>
            № {doc.number || doc.extCode || doc.id}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {dateStr}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }} noWrap title={doc.supplierName || doc.clientName}>
            {doc.supplierName || doc.clientName || '—'}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, flexWrap: 'wrap' }}>
            <Typography variant="body1" fontWeight={600}>
              {formatMoney(doc.sum ?? 0)} ₴
            </Typography>
            <Chip size="small" label={incomingAiStatusLabel(doc)} />
            {unresolved > 0 ? (
              <Chip
                size="small"
                color="warning"
                icon={<WarningAmberOutlinedIcon />}
                label={`Не знайдено: ${unresolved}`}
              />
            ) : doc.isDone ? (
              <CheckCircleOutlineOutlinedIcon color="success" fontSize="small" />
            ) : null}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default IncomingAiInvoiceCard;
